<template>
  <div class="header border-bottom-1px">
    <div class="comment">
      {{commentText}}
    </div>
    <div class="favor">
      {{ favorText }}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'OpusHeader',
    props: {
      commentCount: {
        type: Number,
        default: 0
      },
      favorCount: {
        type: Number,
        default: 0
      },
      keepCount: {
        type: Number,
        default: 0
      },
      shareCount: {
        type: Number,
        default: 0
      }
    },
    computed: {
      commentText() {
        return '评论(' + this.commentCount + ')'
      },
      favorText() {
        return '赞(' + this.favorCount + ')   ' + '转(' + this.shareCount + ')   ' + '藏(' + this.keepCount + ')'
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~stylus/variable.styl'

  .header
    display: flex
    line-height: 32px
    height 32px
    .comment
      margin-left 8px
      font-size: $fontsize-medium
      color: $color-grey
    .favor
      flex: 1
      margin-right 8px
      text-align right
      font-size: $fontsize-small
      color: $color-grey
</style>
